import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const OrderTabDocumentStatusTitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const OrderTabDocumentStatusItemContainer = styled("div")(() => ({
  display: "flex",
  padding: "8px 12px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "8px",

  borderRadius: "8px",
  background: colors.gray50,
}));
